/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PamVerificationDetailSubmittedPiiAddress
 */
export interface PamVerificationDetailSubmittedPiiAddress {
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetailSubmittedPiiAddress
     */
    zip: string;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetailSubmittedPiiAddress
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetailSubmittedPiiAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetailSubmittedPiiAddress
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetailSubmittedPiiAddress
     */
    line1: string;
}

/**
 * Check if a given object implements the PamVerificationDetailSubmittedPiiAddress interface.
 */
export function instanceOfPamVerificationDetailSubmittedPiiAddress(value: object): value is PamVerificationDetailSubmittedPiiAddress {
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('line1' in value) || value['line1'] === undefined) return false;
    return true;
}

export function PamVerificationDetailSubmittedPiiAddressFromJSON(json: any): PamVerificationDetailSubmittedPiiAddress {
    return PamVerificationDetailSubmittedPiiAddressFromJSONTyped(json, false);
}

export function PamVerificationDetailSubmittedPiiAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamVerificationDetailSubmittedPiiAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'zip': json['zip'],
        'state': json['state'],
        'city': json['city'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'line1': json['line1'],
    };
}

export function PamVerificationDetailSubmittedPiiAddressToJSON(value?: PamVerificationDetailSubmittedPiiAddress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'zip': value['zip'],
        'state': value['state'],
        'city': value['city'],
        'line2': value['line2'],
        'line1': value['line1'],
    };
}

